import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import MainCommonView from '../../../../components/common/MainCommonView'
import TanksService from '../../../../services/alvic/tanks/tanks.service'
import ChartBarComp from '../../../../components/common/chart/ChartBarComp'
import { charCommontOptions } from '../../../../utils/helpers/chartOptions'
import { parseProduct } from '../../../../utils/helpers/common'
import TanksDataTable from '../../../../components/alvic/TanksDataTable'

const OwnFuelStationTanks = () => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const [stock, setStock] = useState({})
  const [chartData, setChartData] = useState({})
  const [chartOptions, setChartOptions] = useState({})

  useEffect(() => {
    getByOwnStation()
  }, [])

  useEffect(() => {
    getChartData()
    getChartOptions()
  }, [stock])

  const getByOwnStation = async () => {
    const resp = await TanksService.getById(id)
    if (resp) {
      setStock(resp?.resp)
    }
  }

  const getChartData = () => {
    const datasetsQuantity = {
      type: 'bar',
      label: msg({ id: 'quantity' }),
      backgroundColor: '#2B2E81',
      data: stock?.tanks?.map((tank) => tank.quantity),
    }
    const datasetsRemainingCapacity = {
      type: 'bar',
      label: msg({ id: 'free' }),
      backgroundColor: '#1111',
      data: stock?.tanks?.map((tank) => tank?.remainingCapacity),
    }
    const data = {
      labels: stock?.tanks?.map((tank) => parseProduct(tank?.product)),
      datasets: [datasetsQuantity, datasetsRemainingCapacity],
    }

    setChartData(data)
  }

  const getChartOptions = () => {
    const options = charCommontOptions()
    setChartOptions(options)
  }

  const headerOptions = {
    title: msg({ id: 'tanks' }),
    handlerHeaderActions: {
      showBackButton: true,
    },
  }
  const data = (
    <div className="chart-own-fuel-stock">
      {stock?.tanks?.length > 0 && (
        <ChartBarComp chartData={chartData} chartOptions={chartOptions} />
      )}
      <TanksDataTable value={stock?.tanks} reload={getByOwnStation} />
    </div>
  )

  return <MainCommonView headerOptions={headerOptions} componentData={data} />
}

export default OwnFuelStationTanks
